const list = (items, lang, conjunction = "common:AND") =>
	// prettier-ignore
	!Array.isArray(items) ? items :
  items.length === 0 ? "" :
  items.length === 1 ? items[0] :
  items.length === 2 ? items.join(` $t(${conjunction}) `) :
  [items.slice(0, -1).join(", "), items[items.length - 1]].join(` $t(${conjunction}) `);

export default list;
